/* Patches como linha de cobranca no carrinho.
   Config vem de window.mdPatchesCfg = { variante, handle, checar }
   (escrito no layout/theme.liquid a partir do setting md_patch_produto).
   Fluxo: ao submeter o form da camisa com patch marcado, manda /cart/add com items:[extra, camisa];
   as duas linhas levam a propriedade _md_tie (amarra) e a camisa guarda _md_patches = "P44@Right Sleeve,...".
   A reconciliacao mantem a quantidade do extra igual a (n de patches x quantidade da camisa). */
(function () {
  'use strict';
  if (window.__mdPatchesCarrinho) return;
  window.__mdPatchesCarrinho = true;
  var CFG = window.mdPatchesCfg || {};
  var VARIANTE = parseInt(CFG.variante, 10) || 0;
  var HANDLE = CFG.handle || 'patch';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_ADD = ROOT + 'cart/add';
  var URL_UPDATE = ROOT + 'cart/update';
  var URL_CART = ROOT + 'cart';
  var CHECAR_NA_CARGA = !!CFG.checar;
  var LOCAIS = ['Chest', 'Sleeve', 'Right Sleeve', 'Left Sleeve', 'Legacy', 'Sponsor', 'Match Details', 'Back Sponsor'];
  var ocupado = false, pendente = false, tentativasAdd = {}, MAX_ADD = 3;

  function ehPaginaCarrinho() { return !!document.getElementById('main-cart-items'); }
  function jsonPost(url, corpo) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(corpo) });
  }
  function fnv(txt, semente) {
    var h = semente >>> 0;
    for (var i = 0; i < txt.length; i++) { h ^= txt.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; }
    return h >>> 0;
  }
  function amarra(txt) { return 't' + fnv(txt, 2166136261).toString(36) + '-' + fnv(txt, 16777619).toString(36); }
  function contarCodigos(lista) { if (!lista) return 0; var n = 0; String(lista).split(',').forEach(function (p) { if (p.trim()) n++; }); return n; }
  function ehLinhaExtra(it) {
    if (!it) return false;
    if (it.properties && it.properties._md_addon === '1') return true;
    if (HANDLE && it.handle === HANDLE) return true;
    return false;
  }

  /* ---------- interceptacao do add to cart ---------- */
  function escolhidos(f) {
    var vistos = [];
    function juntar(lista) { Array.prototype.forEach.call(lista, function (el) { if (vistos.indexOf(el) === -1) vistos.push(el); }); }
    juntar(f.querySelectorAll('input[data-md-patch-codigo]:checked'));
    var idDoForm = f.getAttribute('id');
    if (idDoForm) {
      var idSeguro = String(idDoForm).replace(/["\\\]]/g, '');
      juntar(document.querySelectorAll('[data-md-patches-form="' + idSeguro + '"] input[data-md-patch-codigo]:checked'));
    }
    var lista = [];
    vistos.forEach(function (el) {
      var codigo = (el.getAttribute('data-md-patch-codigo') || '').trim();
      var local = (el.getAttribute('data-md-patch-local') || '').trim();
      if (codigo) lista.push({ codigo: codigo, local: local });
    });
    lista.sort(function (a, b) {
      var ia = LOCAIS.indexOf(a.local), ib = LOCAIS.indexOf(b.local);
      if (ia < 0) ia = 99; if (ib < 0) ib = 99;
      if (ia !== ib) return ia - ib;
      if (a.local !== b.local) return a.local < b.local ? -1 : 1;
      if (a.codigo === b.codigo) return 0;
      return a.codigo < b.codigo ? -1 : 1;
    });
    return lista;
  }
  function secoesDoDrawer(drawer) {
    try { if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','); } catch (e) {}
    return 'cart-drawer,cart-icon-bubble';
  }
  function eventoLinhas(f, linhas) {
    var SE = window.StandardEvents || {};
    if (!SE.CartLinesUpdateEvent) return null;
    try {
      var adiado = SE.CartLinesUpdateEvent.createPromise();
      var alvo = (f.closest && f.closest('product-form')) || f;
      alvo.dispatchEvent(new SE.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: linhas, promise: adiado.promise }));
      return adiado;
    } catch (e) { return null; }
  }
  function resolverEventoLinhas(adiado) {
    if (!adiado) return;
    var SE = window.StandardEvents || {};
    if (!SE.CartLinesUpdateEvent) return;
    fetch(URL_CART + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.currency) throw new Error('cart sem currency');
      adiado.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(c) });
    }).catch(function (e) { try { adiado.reject(e); } catch (e2) {} });
  }

  async function adicionarComPatches(f, patches) {
    var botao = f.querySelector('[name="add"], [type="submit"]');
    var girador = f.querySelector('.loading__spinner');
    if (botao) { botao.setAttribute('aria-disabled', 'true'); botao.classList.add('loading'); }
    if (girador) girador.classList.remove('hidden');
    var adiado = null, adicionou = false;
    try {
      var fd = new FormData(f);
      var qtd = parseInt(fd.get('quantity'), 10) || 1;
      var idCamisa = fd.get('id');
      if (!idCamisa) throw new Error('form sem id de variante');
      var props = {}, chaves = [];
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) { props[m[1]] = v; chaves.push(m[1]); } });
      chaves.sort();
      var propsOrdenadas = chaves.map(function (k) { return k + '=' + props[k]; }).join(';');
      var plano = fd.get('selling_plan') || '';
      var codigos = patches.map(function (p) { return p.codigo + '@' + p.local; }).join(',');
      var locais = [];
      patches.forEach(function (p) { if (p.local && locais.indexOf(p.local) === -1) locais.push(p.local); });
      var tie = amarra(String(idCamisa) + '|' + codigos + '|' + propsOrdenadas + '|' + plano);
      props['Patches'] = patches.length + (locais.length ? ' (' + locais.join(', ') + ')' : '');
      props['_md_patches'] = codigos;
      props['_md_tie'] = tie;
      var camisa = { id: idCamisa, quantity: qtd, properties: props };
      if (plano) camisa.selling_plan = plano;
      var extra = { id: VARIANTE, quantity: patches.length * qtd, properties: { _md_tie: tie, _md_addon: '1' } };
      /* extra primeiro no array: o /cart/add lista na ordem inversa, entao a camisa aparece antes do extra */
      var corpo = { items: [extra, camisa] };
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        corpo.sections = secoesDoDrawer(drawer);
        corpo.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') { try { drawer.setActiveElement(document.activeElement); } catch (e) {} }
      }
      adiado = eventoLinhas(f, [{ merchandiseId: idCamisa, quantity: qtd }, { merchandiseId: String(VARIANTE), quantity: extra.quantity }]);
      var res = await jsonPost(URL_ADD, corpo);
      if (!res.ok) throw new Error('cart/add ' + res.status);
      adicionou = true;
      var resp = await res.json();
      if (resp && resp.status) throw new Error(resp.description || resp.message || 'cart/add');
      resolverEventoLinhas(adiado); adiado = null;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'md-patches', productVariantId: idCamisa, cartData: resp }); } catch (e) {}
      }
      if (drawer && resp.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(resp); }
      else window.location.href = URL_CART;
    } catch (e) {
      if (adiado && adiado.reject) { try { adiado.reject(e); } catch (e2) {} }
      if (!adicionou) { try { f.submit(); } catch (e3) {} }
      else window.location.href = URL_CART;
    } finally {
      if (botao) { botao.removeAttribute('aria-disabled'); botao.classList.remove('loading'); }
      if (girador) girador.classList.add('hidden');
    }
  }

  if (VARIANTE) {
    document.addEventListener('submit', function (ev) {
      var f = ev.target, patches;
      try {
        if (!f || !f.getAttribute) return;
        var acao = f.getAttribute('action') || '';
        if (acao.indexOf('/cart/add') === -1) return;
        var campoId = f.querySelector('[name="id"]');
        if (!campoId || !campoId.value) return;
        if (String(campoId.value) === String(VARIANTE)) return;
        patches = escolhidos(f);
        if (!patches.length) return;
      } catch (e) { return; }
      ev.preventDefault();
      ev.stopImmediatePropagation();
      adicionarComPatches(f, patches);
    }, true);
  }

  /* ---------- reconciliacao ---------- */
  function repintarPagina(resp) {
    var itens = document.getElementById('main-cart-items'), rodape = document.getElementById('main-cart-footer'), alvos = [];
    if (itens) alvos.push({ id: 'main-cart-items', secao: itens.dataset.id, seletor: '.js-contents' });
    if (rodape) alvos.push({ id: 'main-cart-footer', secao: rodape.dataset.id, seletor: '.js-contents' });
    alvos.push({ id: 'cart-icon-bubble', secao: 'cart-icon-bubble', seletor: '.shopify-section' });
    alvos.forEach(function (a) {
      var html = resp.sections && resp.sections[a.secao], no = document.getElementById(a.id);
      if (!html || !no) return;
      var destino = no.querySelector(a.seletor) || no;
      var origem = new DOMParser().parseFromString(html, 'text/html').querySelector(a.seletor);
      if (origem) destino.innerHTML = origem.innerHTML;
    });
    var vazio = resp.item_count === 0, lista = document.querySelector('cart-items');
    if (lista) lista.classList.toggle('is-empty', vazio);
    if (rodape) rodape.classList.toggle('is-empty', vazio);
  }
  function repintar(resp) {
    try {
      if (ehPaginaCarrinho()) { repintarPagina(resp); return; }
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !resp || !resp.sections) return;
      if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
        if (resp.item_count === 0) drawer.classList.add('is-empty');
        drawer.renderContents(resp);
      } else {
        var dentroGaveta = document.getElementById('CartDrawer');
        var novaGaveta = resp.sections['cart-drawer'] ? new DOMParser().parseFromString(resp.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer') : null;
        if (dentroGaveta && novaGaveta) {
          dentroGaveta.innerHTML = novaGaveta.innerHTML;
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        var bolha = document.getElementById('cart-icon-bubble');
        if (bolha && resp.sections['cart-icon-bubble']) {
          var tmp = document.createElement('div'); tmp.innerHTML = resp.sections['cart-icon-bubble'];
          var dentro = tmp.querySelector('.shopify-section') || tmp; bolha.innerHTML = dentro.innerHTML;
        }
        if (resp.item_count === 0) drawer.classList.add('is-empty'); else drawer.classList.remove('is-empty');
      }
    } catch (e) {}
  }
  async function reconciliar() {
    if (ocupado) { pendente = true; return; }
    ocupado = true;
    try {
      var carrinho = await (await fetch(URL_CART + '.js', { headers: { Accept: 'application/json' } })).json();
      var itens = (carrinho && carrinho.items) || [], grupos = {}, updates = {}, mudou = false;
      itens.forEach(function (it) {
        var tie = it.properties && it.properties._md_tie;
        if (!tie) return;
        if (!grupos[tie]) grupos[tie] = { alvo: 0, extras: [] };
        if (ehLinhaExtra(it)) grupos[tie].extras.push(it);
        else grupos[tie].alvo += contarCodigos(it.properties._md_patches) * it.quantity;
      });
      var faltando = [];
      Object.keys(grupos).forEach(function (tie) {
        var g = grupos[tie], total = 0;
        g.extras.forEach(function (e) { total += e.quantity; });
        if (total === g.alvo) return;
        if (!g.extras.length) { if (g.alvo > 0 && VARIANTE) faltando.push({ tie: tie, qtd: g.alvo }); return; }
        g.extras.forEach(function (e, i) { var nova = i === 0 ? g.alvo : 0; if (nova !== e.quantity) { updates[e.key] = nova; mudou = true; } });
      });
      itens.forEach(function (it) { if (!ehLinhaExtra(it)) return; var tie = it.properties && it.properties._md_tie; if (!tie) { updates[it.key] = 0; mudou = true; } });
      var addOk = false;
      for (var i = 0; i < faltando.length; i++) {
        var tieFalta = faltando[i].tie;
        tentativasAdd[tieFalta] = (tentativasAdd[tieFalta] || 0) + 1;
        if (tentativasAdd[tieFalta] > MAX_ADD) continue;
        try {
          var resAdd = await jsonPost(URL_ADD, { items: [{ id: VARIANTE, quantity: faltando[i].qtd, properties: { _md_tie: tieFalta, _md_addon: '1' } }] });
          if (resAdd && resAdd.ok) addOk = true;
        } catch (e) {}
      }
      if (!mudou) { if (addOk) { pendente = false; setTimeout(reconciliar, 0); } return; }
      var corpo = { updates: updates };
      if (ehPaginaCarrinho()) {
        var secoes = [], noItens = document.getElementById('main-cart-items'), noRodape = document.getElementById('main-cart-footer');
        if (noItens) secoes.push(noItens.dataset.id);
        if (noRodape) secoes.push(noRodape.dataset.id);
        secoes.push('cart-icon-bubble');
        corpo.sections = secoes.join(','); corpo.sections_url = window.location.pathname;
      } else if (document.querySelector('cart-drawer')) {
        corpo.sections = secoesDoDrawer(document.querySelector('cart-drawer')); corpo.sections_url = window.location.pathname;
      }
      var res = await jsonPost(URL_UPDATE, corpo);
      if (!res.ok) return;
      var resp = await res.json();
      var gavetaFechada = document.querySelector('cart-drawer');
      if (gavetaFechada && gavetaFechada.classList.contains('active')) gavetaFechada = null;
      if (!ehPaginaCarrinho() && gavetaFechada && (!resp.sections || !resp.sections['cart-drawer'])) {
        try {
          var resSec = await fetch(URL_CART + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } });
          if (resSec.ok) { var htmlSec = await resSec.text(); if (htmlSec) { if (!resp.sections) resp.sections = {}; resp.sections['cart-drawer'] = htmlSec; } }
        } catch (e) {}
      }
      repintar(resp);
    } catch (e) {
    } finally {
      ocupado = false;
      if (pendente) { pendente = false; reconciliar(); }
    }
  }
  function instalarGatilhos() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (dados) { if (dados && dados.source === 'md-patches') return; setTimeout(reconciliar, 60); });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var estava = drawer.classList.contains('active');
      new MutationObserver(function () { var agora = drawer.classList.contains('active'); if (agora && !estava) reconciliar(); estava = agora; }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      /* Rede de seguranca: se o cart.js do Dawn repinta a gaveta mas nao chega a publicar cartUpdate
         (ele lanca excecao quando a unica linha restante e a de cobranca), a mudanca no DOM dispara
         a reconciliacao mesmo assim. Debounce de 400 ms; a propria repintura da reconciliacao gera
         no maximo uma passada extra, que nao encontra nada para mudar. */
      var tDom = 0;
      new MutationObserver(function () { clearTimeout(tDom); tDom = setTimeout(reconciliar, 400); }).observe(drawer, { childList: true, subtree: true });
    }
    if (CHECAR_NA_CARGA) reconciliar();
  }
  /* Este arquivo e carregado com defer ANTES do pubsub.js do Dawn: na hora em que roda, `subscribe`
     ainda nao existe e o DOMContentLoaded ainda nao disparou de verdade (readyState = interactive).
     Por isso os gatilhos so sao instalados no load, quando todos os scripts defer ja executaram. */
  if (document.readyState === 'complete') instalarGatilhos(); else window.addEventListener('load', instalarGatilhos);
})();
